"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Logo = _interopRequireDefault(require("../Logo"));

var _History = require("../../util/History");

var _Urls = require("../../util/Urls");

var _LanguageSwitcher = _interopRequireDefault(require("../LanguageSwitcher"));

var _Paths = require("../../constants/Paths");

var navigateHome = function navigateHome() {
  return (0, _History.navigateTo)(_Paths.ROOT + "?" + (0, _Urls.parseUtmParams)());
};

var Title = function Title() {
  return _react.default.createElement("div", {
    className: "title"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "meta.title"
  }));
};

var _default = function _default() {
  return _react.default.createElement("div", {
    className: "main-toolbar"
  }, _react.default.createElement("div", {
    className: "logo-left"
  }, _react.default.createElement(_Logo.default, {
    onClick: navigateHome
  }), _react.default.createElement(Title, null)), _react.default.createElement(_LanguageSwitcher.default, null));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/header/MainToolBar.js
// module id = 315
// module chunks = 0